import { formatDate } from 'utils/formatDate';

/* Named input: `locale` and `timeZone` are both `string | undefined`, so transposing them compiles. */
interface BookingWhenInput {
  start?: string;
  end?: string;
  locale?: string;
  timeZone?: string;
}

/*
 * One date and a time range, or both dates when it crosses local midnight.
 *
 * The overnight comparison is between FORMATTED dates, not timestamps: 'spans two days' is a question
 * about the DISPLAY timezone. 22:00Z to 02:00Z crosses the UTC date line but is one evening in New York.
 */
export const bookingWhen = ({ start, end, locale, timeZone }: BookingWhenInput): string | null => {
  if (!start) {
    return null;
  }

  const from = formatDate(start, locale, timeZone);

  if (!end) {
    return `${from.formattedFullDate} · ${from.formatEventStartTime}`;
  }

  const to = formatDate(end, locale, timeZone);

  return from.formattedFullDate === to.formattedFullDate
    ? `${from.formattedFullDate} · ${from.formatEventStartTime} - ${to.formatEventStartTime}`
    : `${from.formattedFullDate} ${from.formatEventStartTime} - ${to.formattedFullDate} ${to.formatEventStartTime}`;
};
